import { createStore } from 'effector';

export const $isAbsolute = createStore(false);
$isAbsolute.watch((state) => console.log('$isAbsolute', state));

export const $absoluteLayers = createStore([]);
$absoluteLayers.watch((state) => console.log('$absoluteLayers', state));
export const $absoluteInfoData = createStore([]);

// FIXME Point Layers translation
// kg - Детские сады
// sc - Школы +
// st - Остановки +
// fc_ss - Фитнес центры и Спортивные секции
// gc - Мусорные контейнеры
// hos - Больницы +
// pol - Взрослые поликлиники + Детские поликлиники
// con - ЦОН
// fa - Скорая медицинская помощь +
export const $kgPoints = createStore([]);
export const $kgStartPoints = createStore([]);
export const $scPoints = createStore([]);
export const $scStartPoints = createStore([]);
export const $stPoints = createStore([]);
export const $stStartPoints = createStore([]);
export const $fc_ssPoints = createStore([]);
export const $fc_ssStartPoints = createStore([]);
export const $gcPoints = createStore([]);
export const $gcStartPoints = createStore([]);
export const $hosPoints = createStore([]);
export const $hosStartPoints = createStore([]);
export const $polPoints = createStore([]);
export const $polStartPoints = createStore([]);
export const $conPoints = createStore([]);
export const $conStartPoints = createStore([]);
export const $faPoints = createStore([]);
export const $faStartPoints = createStore([]);
